<template>
  <Modal
    :title="title"
    :width="width"
    v-model="showDialog"
    :mask-closable="false" sticky reset-drag-position :mask="false" draggable
    @on-visible-change="closeDialog"
  >
    <div class="line">
      <label v-if="nounType==='1'" class="prefix"><span style="color: red">*</span>名词名称：</label>
      <label v-else class="prefix"><span style="color: red">*</span>名词名称：</label>
      <el-input v-model="nounData.name" size="small" placeholder="限制30个字符" :maxlength="30" class="suffix"></el-input>
    </div>
    <!--名词表格-->
    <div v-if="nounType==='1'" class="line">
      <label class="prefix">名词成员：</label>
      <el-table
        :data="nounData.nouns"
        border
        style="width: 75%;display: inline-grid;margin-top: 10px;">
        <el-table-column
          width="100"
          label="名词成员">
          <template slot-scope="scope">
            <el-input v-model="scope.row.member" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="同义词">
          <template slot-scope="scope">
            <el-tag
              v-for="(tag,index) in scope.row.thesaurus"
              :key="index"
              type="info"
              closable
              :disable-transitions="false"
              @close="handleClose(scope.$index,tag)">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="scope.row.inputVisible"
              v-model="inputValue"
              :ref="`saveTagInput`+scope.$index"
              size="small"
              @keyup.enter.native="handleInputConfirm(scope.$index)"
              @blur="handleInputConfirm(scope.$index)"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput(scope.$index)">+ New Tag</el-button>
          </template>
        </el-table-column>
        <el-table-column
          width="60"
          label="操作">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" @click="handleDelete(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px">
        <a @click="handleAdd" style="margin-left: 20%;">+新增名词成员</a>
      </div>
    </div>
    <!--正则-->
    <div v-if="nounType==='0'" class="line" style="height: 35px">
      <label class="prefix"><span style="color: red">*</span>正则表达式：</label>
      <el-input v-model="nounData.expression" size="small" class="suffix" placeholder="正则表达式" @blur="handleRegex"></el-input>
    </div>
    <!--测试表达式-->
    <div v-if="nounType==='0'" class="line" style="height: 150px">
      <label class="prefix">测试表达式：</label>
      <el-input v-model="testValue" size="small" type="textarea" class="suffix" :rows="5" resize="none" @blur="handleTest"></el-input>
    </div>
    <!--测试结果-->
    <div v-if="nounType==='0'" class="line" style="height: 35px">
      <label class="prefix">测试结果：</label>
      <label class="suffix" style="line-height: 30px">{{testResult}}</label>
    </div>
    <div slot="footer">
      <el-button type="primary" @click.prevent="submitNonu" size="small">确定</el-button>
      <el-button @click="cancelNoun" size="small">取消</el-button>
    </div>
  </Modal>
</template>

<script>
  import {clone} from "../../../util/tools";

  export default {
    name: "NonuDialog",
    props:['nounId','isEdit','type','show','flowId'],
    data(){
      return {
        nounData:{
          type:1,
          expression:'',
          id:'',
          nouns:[],
          name:''
        },
        showDialog:false,
        title:'新建名词',
        width:'600',
        nounType:'1',
        inputVisible:false,
        inputValue:'',
        testValue:'',
        testResult:'无匹配结果',
        isRegex:false
      }
    },
    methods:{
      loadData(id) {
        let that = this
        let param = {rwId:this.flowId, nounId: id}
        this.$http.post('/AI/FlowDetail/queryNounById',param).then(res=>{
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          let data = response.obj
          this.nounType = data.type + ''
          let json = {}
          json.name = data.name
          json.type = data.type
          json.id = data.id
          json.expression = data.expression
          json.nouns = []
          if (data.thesauses.length > 0) {
            let arr = []
            data.thesauses.forEach(the => {
              let noun = {}
              noun.id = the.id
              noun.member = the.member
              noun.thesaurus = the.thesaurus.split(',').filter(item => {
                return item !== ''
              })
              noun.inputVisible = false
              arr.push(noun)
            })
            json.nouns = arr
          }
          this.nounData = json
        })
      },
      closeDialog(val) {
        this.$emit('close',val)
      },
      cancelNoun() {
        this.showDialog=false
        this.reset()
      },
      reset() {
        this.nounData = {
            type:1,
            expression:'',
            id:'',
            nouns:[],
            name:''
          }
        this.inputVisible=false
        this.inputValue=''
        this.testValue=''
        this.testResult='无匹配结果'
        this.isRegex=false
      },
      submitNonu() {
        let that = this
        let nouns = clone(this.nounData.nouns)
        if (nouns.length > 0) {
          nouns.forEach(noun=>{
            noun.thesaurus = noun.thesaurus.join(",")
          })
        }
        if (!this.nounData.name) {
          this.$Message.info('名词名称不能为空！');
          return;
        }
        if (this.nounType === '1') {

        }else if (this.nounType === '0') {
          if (!this.nounData.expression) {
            this.$Message.info('正则表达式不能为空！');
            return
          }
        }
        let param = {
          rwId:this.flowId,
          name:this.nounData.name,
          type:this.nounData.type,
          thesaurus:JSON.stringify(nouns),
          expression:this.nounData.expression
        };
        let url = ''
        let message = ''
        if (this.isEdit) {
          param.id = this.nounData.id;
          param.menuId = 'a_2-8'
          param.journalType = 'AI机器人管理=>AI流程管理=>编辑专有名词'
          url = '/AI/FlowDetail/updateNoun'
          message = '编辑专有名词成功'
        } else {
          param.id = ''
          param.menuId = 'a_2-8'
          param.journalType = 'AI机器人管理=>AI流程管理=>新建专有名词'
          url = '/AI/FlowDetail/addNoun';
          message = '新增专有名词成功'
          /*if (this.nounType === '2') {
            if (this.isRegex) {
              url = '/AI/FlowDetail/addNoun';
            }
          } else {
            url = '/AI/FlowDetail/addNoun';
          }*/
        }
        if (url) {
          this.$http.post(url,param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
            } else {
              that.$Message.success(message)
              that.showDialog = false
            }
          })
        }
      },
      handleClose(index,tag) {
        let nindex = this.nounData.nouns[index].thesaurus.indexOf(tag)
        if (nindex > -1) {
          this.nounData.nouns[index].thesaurus.splice(nindex,1)
        }
      },
      showInput(index) {
        this.inputVisible = true
        this.nounData.nouns[index].inputVisible = true
        this.$nextTick(_=>{
          let ref = 'saveTagInput'+index
          this.$refs[ref].$refs.input.focus()
        })
      },
      handleInputConfirm(index) {
        let inputValue = this.inputValue
        if (inputValue) {
          this.nounData.nouns[index].thesaurus.push(inputValue)
        }
        this.inputVisible = false
        this.nounData.nouns[index].inputVisible = false
        this.inputValue = ''
      },
      handleAdd() {
        this.nounData.nouns.push({id:'',member:'',thesaurus:[],inputVisible:false})
      },
      handleDelete(index, row) {
        this.nounData.nouns.splice(index,1)
      },
      handleRegex() {
        let regex = this.nounData.expression
        if (!regex) {
          this.$Message.warning('请输入正则表达式');
          this.isRegex = false;
          return;
        } else {
          this.isRegex = true
        }
        /*try {
          let isReg = eval(regex) instanceof RegExp
          if (!isReg) {
            this.$Message.warning('请输入正确的正则表达式')
            this.isRegex = false
            return
          }
          this.isRegex = true
        }catch (e) {
          this.$Message.warning('请输入正确的正则表达式')
          console.log(e)
        }*/
      },
      handleTest() {
        //todo 高亮显示，待做
        //验证正则表达式
        let regex = this.nounData.expression
        if (!regex) {
          this.$Message.warning('请输入正则表达式')
          return
        }
        /*let reg = eval(regex)
        if (!(reg instanceof RegExp)) {
          reg = eval("/^"+regex+"$/")
        }*/
        let reg = new RegExp(regex,"g");
        let testValue = this.testValue
        //let result = reg.exec(testValue)
        let result = testValue.match(reg)
        if (result) {
          this.testResult = result;
        } else {
          this.testResult = '无匹配结果'
        }
      }
    },
    watch:{
      show:{
        deep:true,
        immediate:true,
        handler(val) {
          this.showDialog = this.show
          if (val) {
            if (this.isEdit) {
              this.loadData(this.nounId)
            } else {
              this.nounData = {
                type:this.type,
                expression:'',
                id:'',
                nouns:[],
                name:''
              }
            }
          }
        }
      },
      type:{
        deep:true,
        handler(val) {
          if (!this.isEdit) {
            this.nounType = val
            this.nounData.type = val
          }
        }
      },
      isEdit:{
        deep:true,
        handler(val) {
          if (val) {
            this.title = '编辑名词'
          } else {
            this.title = '新建名词'
            this.nounType = this.type
          }
        }
      }
    }
  }
</script>

<style scoped lang="css">
.prefix{
  width: 20%;
  text-align: right;
  float: left;
  line-height: 32px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.suffix{
  width: 75%;
  float: left;
  margin-top: 5px;
  margin-bottom: 5px;
}
  .el-tag + .el-tag {
    margin-left: 10px;
    margin-top: 5px;
  }
  .button-new-tag{
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 5px;
  }
  .input-new-tag{
    width: 90px;
    margin-left: 10px;
    margin-top: 5px;
    vertical-align: bottom;
  }
  .line{
    margin-top: 10px;
  }
  a{
    color: #3da8f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow/components/NonuDialog.vue